import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const navConfig = [
  {
    title: 'Penagihan Eksternal',
    path: '/mis/penagihan-eksternal',
    icon:  <Iconify icon={'ant-design:file-text-filled'} />,
  },
  {
    title: 'Mutasi Transaksi',
    path: '/mis/mutasi-transaksi',
    icon:  <Iconify icon={'ant-design:pushpin-filled'} />,
  },
];

export default navConfig;
